import { Box, Paper, Typography } from '@material-ui/core'
import React from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../../../lib/hooks/languageHooks'
import { useProxyPath } from '../../../redux/hook/settingsHooks'
import getStatusText from '../functions'
import useStyles from '../styles'
import TrackingButton from './TrackingButton'

const DesktopOrderPaper = ({ orderData, getDateFormat, customerOrder }) => {
    const classes = useStyles()
    const language = useLanguage()
    const proxyPath = useProxyPath()

    return (
        <Paper className={classes.root}>
            <Box className={classes.flexRow}>
                <Box className={classes.flexItem}>
                    <Typography>
                        {getDateFormat(customerOrder.OrderDate)}
                    </Typography>
                </Box>
                <Box className={classes.flexItem}>
                    <Link to={`${proxyPath}/${language}/order/${customerOrder.OrderNumber}`}>
                        <Typography>
                            {customerOrder.OrderNumber}
                        </Typography>
                    </Link>
                </Box>
                <Box className={classes.flexItem}>
                    <Box className={classes.flexColumn}>
                        {getStatusText(customerOrder.Status)}
                    </Box>
                </Box>
                <TrackingButton orderNumber={customerOrder.OrderNumber} shippingArray={customerOrder.Shipments} />
                {orderData.map((title, index) => {
                    return (
                        <Box className={classes.flexItem} key={index}>
                            <Typography>
                                {title}
                            </Typography>
                        </Box>
                    )
                })}
            </Box>
        </Paper>
    )
}

export default DesktopOrderPaper